// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type PerformanceReviewExclusionChoicesQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
  lastWorkingDate: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;

export type PerformanceReviewExclusionChoicesQuery = { __typename?: 'Query' } & {
  performanceReviewExclusionChoices: { __typename?: 'PerformanceReviewExclusionChoices' } & {
    choices: Array<
      { __typename?: 'PerformanceReviewExclusionChoice' } & Pick<
        Types.PerformanceReviewExclusionChoice,
        'stage' | 'performanceReviewId'
      > & {
          period: { __typename?: 'PerformanceReviewPeriod' } & Pick<
            Types.PerformanceReviewPeriod,
            'year' | 'quarter' | 'version'
          >;
        }
    >;
    selected: Types.Maybe<
      { __typename?: 'PerformanceReviewExclusionChoice' } & Pick<
        Types.PerformanceReviewExclusionChoice,
        'performanceReviewId'
      > & {
          period: { __typename?: 'PerformanceReviewPeriod' } & Pick<
            Types.PerformanceReviewPeriod,
            'year' | 'quarter' | 'version'
          >;
        }
    >;
  };
};

export const PerformanceReviewExclusionChoicesDocument = /*#__PURE__*/ gql`
    query PerformanceReviewExclusionChoices($employeeId: ID!, $lastWorkingDate: Date) {
  performanceReviewExclusionChoices(
    employeeId: $employeeId
    lastWorkingDate: $lastWorkingDate
  ) {
    choices {
      period {
        year
        quarter
        version
      }
      stage
      performanceReviewId
    }
    selected {
      period {
        year
        quarter
        version
      }
      performanceReviewId
    }
  }
}
    `;

/**
 * __usePerformanceReviewExclusionChoicesQuery__
 *
 * To run a query within a React component, call `usePerformanceReviewExclusionChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceReviewExclusionChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceReviewExclusionChoicesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      lastWorkingDate: // value for 'lastWorkingDate'
 *   },
 * });
 */
export function usePerformanceReviewExclusionChoicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PerformanceReviewExclusionChoicesQuery,
    PerformanceReviewExclusionChoicesQueryVariables
  > &
    ({ variables: PerformanceReviewExclusionChoicesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PerformanceReviewExclusionChoicesQuery, PerformanceReviewExclusionChoicesQueryVariables>(
    PerformanceReviewExclusionChoicesDocument,
    options,
  );
}
export function usePerformanceReviewExclusionChoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PerformanceReviewExclusionChoicesQuery,
    PerformanceReviewExclusionChoicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PerformanceReviewExclusionChoicesQuery, PerformanceReviewExclusionChoicesQueryVariables>(
    PerformanceReviewExclusionChoicesDocument,
    options,
  );
}
// @ts-expect-error
export function usePerformanceReviewExclusionChoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PerformanceReviewExclusionChoicesQuery,
    PerformanceReviewExclusionChoicesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PerformanceReviewExclusionChoicesQuery,
  PerformanceReviewExclusionChoicesQueryVariables
>;
export function usePerformanceReviewExclusionChoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PerformanceReviewExclusionChoicesQuery,
        PerformanceReviewExclusionChoicesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PerformanceReviewExclusionChoicesQuery | undefined,
  PerformanceReviewExclusionChoicesQueryVariables
>;
export function usePerformanceReviewExclusionChoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PerformanceReviewExclusionChoicesQuery,
        PerformanceReviewExclusionChoicesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PerformanceReviewExclusionChoicesQuery,
    PerformanceReviewExclusionChoicesQueryVariables
  >(PerformanceReviewExclusionChoicesDocument, options);
}
export type PerformanceReviewExclusionChoicesQueryHookResult = ReturnType<
  typeof usePerformanceReviewExclusionChoicesQuery
>;
export type PerformanceReviewExclusionChoicesLazyQueryHookResult = ReturnType<
  typeof usePerformanceReviewExclusionChoicesLazyQuery
>;
export type PerformanceReviewExclusionChoicesSuspenseQueryHookResult = ReturnType<
  typeof usePerformanceReviewExclusionChoicesSuspenseQuery
>;
